import { createSlice } from "@reduxjs/toolkit";
import { useNavigate } from "react-router-dom";
// utils
import axios from "../../utils/axios";
import { PATH_DASHBOARD } from "../../routes/paths";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  update: false,
  faqs: [],
  fetchLoading: false,
};

const slice = createSlice({
  name: "faq",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // START LOADING
    fetchLoading(state) {
      state.fetchLoading = true;
    },
    // UPDATE EVENT
    updateFaqSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.faqs = state.faqs.map((event) => {
        if (event.id === action.payload.id) {
          return action.payload;
        }
        return event;
      });
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.update = false;
      state.error = action.payload;
    },

    // GET PRODUCTS
    getFaqSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.faqs = action.payload;
    },

    // GET PRODUCTS
    createFaqSuccess(state, action) {
      state.isLoading = false;
      state.fetchLoading = false;
      state.faqs = [...state.faqs, action.payload];
    },

    // DELETE EVENT
    deleteFaqSuccess(state, action) {
      const eventId = action.payload;
      state.faqs = state.faqs.filter((event) => event.id !== eventId);
      state.isLoading = false;
      state.fetchLoading = false;
    },
  },
});

export default slice.reducer;

export function getFaqs() {
  return async (dispatch) => {
    dispatch(slice.actions.fetchLoading());
    try {
      const response = await axios.get("faqs");
      dispatch(slice.actions.getFaqSuccess(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function createFaqs({ data, enqueueSnackbar, navigate }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post("faqs", data);
      dispatch(slice.actions.createFaqSuccess(response.data.data));
      enqueueSnackbar("Faq is added successfully");
      navigate(PATH_DASHBOARD.manage.faqs);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function updateFaqs({
  id,
  data,
  enqueueSnackbar,
  navigate,
  setOpenEdit,
}) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.patch(`faqs/${id}`, data);
      dispatch(slice.actions.updateFaqSuccess(response.data.data));
      enqueueSnackbar("Faq is updated successfully");
      setOpenEdit(false);
      navigate(PATH_DASHBOARD.manage.faqs);
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });

      dispatch(slice.actions.hasError(error));
    }
  };
}

export function deleteFaqs({ id, enqueueSnackbar }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.delete(`faqs/${id}`);
      dispatch(slice.actions.deleteFaqSuccess(id));
      enqueueSnackbar("Faq is deleted successfully");
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
      });
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
